import { Box, Typography } from "@mui/material";
import Logo from "../assets/logo.png";
import { grayColor, lightBlackColor } from "../constants/colors";

const Header = ({ setIsModalOpen }) => {
  return (
    <Box
      sx={{
        margin: "0 auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        maxWidth: "1325px",
        width: "100%",
        paddingX: "20px",
        paddingTop: "30px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
        }}
      >
        <img src={Logo} style={{ width: "60px", height: "60px" }} alt="logo" />
        <Typography
          sx={{
            color: lightBlackColor,
            fontWeight: "500",
            fontFamily: "Roboto",
            fontSize: "36px",
          }}
        >
          WebRender
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: "20px" }}>
        <a
          className="link-text"
          href="https://www.dropbox.com/scl/fo/lcqsnugovdhxz586covtw/AKurYBR8vA0cVQ1gIIzgolM?rlkey=u6ltnli6cgyrh4p6mfjz84hjh&e=34&st=w02jvre4&dl=0"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            transition: "color 0.3s",
            textDecoration: "none",
            color: grayColor,
            fontSize: "20px",
            fontWeight: "500",
            fontFamily: "Roboto",
          }}
        >
          Renders
        </a>
        <a
          className="link-text"
          href="https://docs.google.com/spreadsheets/d/1qyyNZfppqLXtRjXgE2_PpVTaJhgtA5z6_3voFq3jcuQ/edit?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            transition: "color 0.3s",
            textDecoration: "none",
            color: grayColor,
            fontSize: "20px",
            fontWeight: "500",
            fontFamily: "Roboto",
          }}
        >
          Jobs progress
        </a>
        <Typography
          onClick={() => setIsModalOpen(true)}
          className="link-text"
          sx={{
            cursor: "pointer",
            transition: "color 0.3s",
            textDecoration: "none",
            color: grayColor,
            fontSize: "20px",
            fontWeight: "500",
            fontFamily: "Roboto",
          }}
        >
          New Template
        </Typography>
        <a
          className="link-text"
          href="https://www.notion.so/homagames/Web-Render-bee370fd0c14478fa661162c625324ff?pvs=4"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            transition: "color 0.3s",
            textDecoration: "none",
            color: grayColor,
            fontSize: "20px",
            fontWeight: "500",
            fontFamily: "Roboto",
          }}
        >
          Tutorial
        </a>
      </Box>
    </Box>
  );
};

export default Header;
